import { sendToTerminal } from '../../terminalLogger';

/**
 * Centralized logging helpers for tools
 * Eliminates code duplication and standardizes log format
 */

/**
 * Logs session state check for a tool
 * @param toolName Name of the tool (e.g., 'RUNPS', 'ONEAGRUPAR', 'METADADOS')
 */
export function logSessionState(toolName: string): void {
  const hasToken = !!(window as any)?.sessionToken;
  const sessionToken = (window as any)?.sessionToken
    ? '***' + String((window as any)?.sessionToken).slice(-8)
    : null;

  sendToTerminal(`🔍 [${toolName}] Estado da sessão`, {
    hasToken,
    sessionToken
  });
}

/**
 * Logs tool execution result (error, success, or timeout)
 * Only logs errors and timeouts - success is implicit if no error
 * @param toolName Name of the tool
 * @param result Response from tool execution
 */
export function logToolResult(toolName: string, result: any): void {
  if (!result) return;

  const status = result?.status || result?.Status;

  if (status === 'error' || status === 'erro') {
    sendToTerminal(`❌ [${toolName}] Erro na execução`, {
      status,
      message: result?.message || result?.Message,
      requestId: result?.requestId
    });
  } else if (status === 'timeout') {
    sendToTerminal(`⏱️ [${toolName}] Timeout na execução`, {
      status,
      message: result?.message || result?.Message,
      requestId: result?.requestId
    });
  } else {
    // Log success with details to help debugging
    sendToTerminal(`✅ [${toolName}] Execução finalizada`, {
      status: status || 'ok',
      result: result, // Log full result object
      requestId: result?.requestId
    });
  }
}

/**
 * Logs when an action is sent to C#
 * @param toolName Name of the tool
 * @param action Action name being sent
 * @param requestId Request ID for tracking
 */
export function logActionSent(toolName: string, action: string, requestId: string): void {
  sendToTerminal(`📤 [${toolName}] Action enviada`, {
    action,
    requestId
  });
}

/**
 * Logs response received from C#
 * @param toolName Name of the tool
 * @param response Response object from C#
 */
export function logActionResponse(toolName: string, response: any): void {
  if (!response) {
    sendToTerminal(`⚠️ [${toolName}] Resposta vazia`, {});
    return;
  }

  const status = response?.status;

  if (status === 'ok') {
    // Resposta OK - silencioso (sucesso é implícito)
  } else if (status === 'error' || status === 'erro') {
    sendToTerminal(`❌ [${toolName}] Resposta com erro`, {
      status,
      message: response?.message,
      requestId: response?.requestId
    });
  } else {
    sendToTerminal(`📥 [${toolName}] Resposta recebida`, {
      status,
      requestId: response?.requestId
    });
  }
}

